import React from 'react';
import themeVariables from '~/shared/themeVariables';
import IconNext from '~/components/svg/icon-next-ai-landing-page-item.svg';

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      t,
      reverse,
      src,
      iconHeader,
      title,
      content,
      href,
      positionHref,
    } = this.props;
    console.log('day la positionHref', positionHref);
    return (
      <div className={`item-container ${reverse ? 'reverse' : ''}`}>
        <div className="img-item-container">
          <img className="img-item" src={src} />
        </div>
        <div className="data-item-container">
          <div className="header-item-container">
            <div className="icon-header">{iconHeader}</div>
            <div className="title-header">{title}</div>
          </div>
          <div
            className="data-text"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
          <div
            className={`icon-next-container ${positionHref ? 'reverse' : ''}`}
          >
            <a href={href} target="_blank" rel="noreferrer">
              <IconNext />
            </a>
          </div>
        </div>

        <style jsx>{`
          .content-container {
          }
          .item-container {
            width: 100%;
            background: #f8f9fa;
            display: flex;
            flex-direction: row;
          }
          .item-container.reverse {
            flex-direction: row-reverse;
          }
          .img-item-container {
            width: 100%;
            flex-basis: 50%;
          }
          .img-item {
            width: 100%;
            flex: 1;
          }
          .data-item-container {
            width: 100%;
            flex: 1;
            padding: 32px;
          }
          .header-item-container {
            display: flex;
            justify-content: space-between;
            height: 48px;
          }
          .icon-header {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: fit-content;
          }
          .title-header {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: end;
            justify-content: center;
            width: 100%;
            font-weight: 600;
          }
          .data-text {
            margin-top: 16px;
            font-weight: 500;
            font-size: 16px;
          }
          .icon-next-container {
            display: flex;
            align-items: flex-start;
            margin-top: 48px;
          }
          .icon-next-container.reverse {
            justify-content: end;
          }
          @media (max-width: ${themeVariables.breakpoints.tabletL.maxWidth}px) {
            .img-item {
              width: 100%;
              flex: 1;
              height: 100%;
              object-fit: cover;
            }
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .item-container {
              width: 100%;
              background: #f8f9fa;
              display: flex;
              flex-direction: column;
            }
            .item-container.reverse {
              flex-direction: column;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default Item;
